import { AxiosError } from 'axios';
import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

function trimTrailingSlash(s = '') {
  return s.replace(/\/$/, '');
}

function trimLeadingSlash(s = '') {
  return s.replace(/^\//, '');
}

function formatUrl(config: InternalAxiosRequestConfig) {
  const url = config.baseURL
    ? [trimTrailingSlash(config.baseURL), trimLeadingSlash(config.url)].join('/')
    : config.url;
  return url ? url : '';
}

function extractMessage(res: AxiosResponse): string | undefined {
  return res.data?.message || res.data?.error?.message;
}

function formatSummary({
  url,
  method,
  status,
  message,
}: {
  url: string;
  method: string;
  status?: number;
  message?: string;
}) {
  const statusPrefix = status ? `[${status}] ` : '';
  const messageSuffix = message ? ` (${message})` : '';
  return `${statusPrefix}${method} ${url}${messageSuffix}`;
}

export function enhanceAxiosErrorMessage(error: AxiosError, extractMessageFn = extractMessage) {
  const config = error.config;
  if (!config) {
    return;
  }
  const method = (config.method || 'GET').toUpperCase();
  const url = formatUrl(config);
  const status = error.status;
  const message = error.response ? extractMessageFn(error.response) : error.message;
  const enhancedMessage = formatSummary({
    url,
    method,
    status,
    message,
  });

  return enhancedMessage;
}
